// extracted by mini-css-extract-plugin
module.exports = {"anchorSectionContainer":"bL_fj","allArticlesAnchorToSection":"bL_fk","mobileLink":"bL_cH"};